<template>
  <KeywordsMiniHeader
    @focus="searchFocus = true"
    :is-show="showMiniHeader"
  />
  <KeywordsHeader
    @focus="searchFocus = true"
    :hidden="showMiniHeader"
    :can-input="false"
  />
  <H5SearchFoucs
    v-if="searchFocus"
    @back="searchFocus = false"
  />
</template>

<script setup>
import KeywordsHeader from '@/components/H5/KeywordsHeader/index.vue'
import KeywordsMiniHeader from '@/components/H5/KeywordsMiniHeader/index.vue'
import H5SearchFoucs from '@/components/H5/H5SearchFoucs/index.vue'
import { fetchData } from '@/utils/fetch'
import { useEventListener } from '@vueuse/core'
import { useValidCache } from '@/hooks/useValidCache'
import storage from '@/utils/storage'

const store = useStore()

const searchFocus = ref(false)
const showMiniHeader = ref(false)

useEventListener(window, 'scroll', (e) => {
  const scrollTop = e.target.scrollingElement.scrollTop
  if (scrollTop > 120) {
    showMiniHeader.value = true
  } else {
    showMiniHeader.value = false
  }
})

/**
 * TODO: 临时初始化数据，后续可以直接配置进 Layout 里，并且自动从本地获取初始化数据
 */
onBeforeMount(() => {
  getCountry()
  getCurrencyList()
})

const getCountry = async () => {
  const { cacheData, CACHE_VERSION } = useValidCache('cacheCountryList')
  if (cacheData.value) {
    store.commit('setCountryInfo', cacheData.value.data)

    const countryObj = localStorage.getItem('setCurrentCountry')
      ? JSON.parse(localStorage.getItem('setCurrentCountry'))
      : cacheData.value.data[0]
    store.commit('setCurrentCountry', countryObj)
    return
  }

  const { code, data } = await fetchData('/dsp-app/alibaba-common/country')
  if (code === 200) {
    const cacheData = {
      data,
      timestamp: Date.now(),
      cache_version: CACHE_VERSION
    }
    localStorage.setItem('cacheCountryList', JSON.stringify(cacheData))

    store.commit('setCountryInfo', data)

    const countryObj = localStorage.getItem('setCurrentCountry')
      ? JSON.parse(localStorage.getItem('setCurrentCountry'))
      : data[0]
    store.commit('setCurrentCountry', countryObj)
  }
}

const getCurrencyList = async () => {
  const { code, data } = await fetchData('/dsp-app/alibaba-common/currencyList')
  if (code === 200) {
    const _cache = storage.get('currencyData')
    let target
    if (_cache) {
      target = data.find(item => item.targetCurrency === _cache.targetCurrency)
    } else {
      target = data[0]
    }

    store.commit('setCurrencyList', data)
    store.commit('setCurrencyData', target)
    storage.set('currencyData', target)
  }
}
</script>

<style lang="less" scoped>

</style>
